import "../App.css";
import axios from "axios";
import { useState, useEffect } from "react";
import { ProgressBar, ThreeDots } from "react-loader-spinner";
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDownloadURL, ref, getStorage } from "firebase/storage";
import {
  getDatabase,
  ref as dbRef,
  set,
  push,
  get,
  serverTimestamp,
  onValue,
  query,
  orderByChild,
  limitToLast,
} from "firebase/database";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { HorizontalTicker } from "react-infinite-ticker";

import ReactAudioPlayer from "react-audio-player";

function Main() {
  const [callPending, setCallPending] = useState(false);
  const [callResponse, setCallResponse] = useState("");
  const [audioFile, setAudioFile] = useState("");
  const [downloadURL, setDownloadURL] = useState("");
  const [prompt, setPrompt] = useState("");
  const [voice, setVoice] = useState({
    "American Male Voice 1": "en-US-ChristopherNeural",
    "French Male Voice": "fr-FR-CelesteNeural",
    "Spanish Male Voice": "es-US-PalomaNeural",
    "American Female Voice 1": "en-US-AriaNeural",
    "French Female Voice": "fr-FR-HenriNeural",
    "Spanish Female Voice": "es-US-AlonsoNeural",
    //  "American Female Voice 2": "en-US-Studio-O",
    // "American Male Voice 1": "en-US-Studio-M",
  });
  const [selectedVoice, setSelectedVoice] = useState(Object.values(voice)[0]);
  const [imageScale, setImageScale] = useState(1);
  const [recentSearches, setRecentSearches] = useState([]);
  const [lastSubmitted, setLastSubmitted] = useState("");
  const [viewCounter, setViewCounter] = useState(0);
  const [recentSearchString, setRecentSearchString] = useState("");
  const [randomLoading, setRandomLoading] = useState(false);

  const [lastSearch, setLastSearch] = useState({
    prompt: "",
    result: "",
  });

  const firebaseConfig = {
    apiKey: "AIzaSyB7D3p41RmiAOp_cbFJB2pUPb9a33J4IPI",
    authDomain: "aipodcastmania.firebaseapp.com",
    databaseURL: "https://aipodcastmania-default-rtdb.firebaseio.com",
    projectId: "aipodcastmania",
    storageBucket: "aipodcastmania.appspot.com",
    messagingSenderId: "514246671749",
    appId: "1:514246671749:web:7cf93b54e798c8be8d58ec",
    measurementId: "G-XKJ38EFBKN",
  };

  const app = initializeApp(firebaseConfig);
  const functions = getFunctions(app);
  const db = getDatabase(app);
  const storage = getStorage(app);

  useEffect(() => {
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        // store user ip address in database
        const ipRef = dbRef(db, "ip");
        // push new ip address to database
        push(ipRef, response.data.ip);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    const viewRef = dbRef(db, "views");
    get(viewRef).then((snapshot) => {
      if (snapshot.exists()) {
        console.log(snapshot.val());
        set(viewRef, snapshot.val() + 1);
      } else {
        console.log("No data available");
        set(viewRef, 1);
      }
    });

    onValue(viewRef, (snapshot) => {
      setViewCounter(snapshot.val());
    });
  }, []);

  useEffect(() => {
    // get download url for audio file
    if (audioFile !== "") {
      console.log("checking download url");
      const storage = getStorage(app);
      const storageRef = ref(storage, `audio/${audioFile}.mp3`);
      getDownloadURL(storageRef)
        .then((url) => {
          setDownloadURL(url);
          console.log(url);
          console.log(prompt.trim() !== lastSearch.prompt.trim());
          console.log(prompt.trim());
          console.log(lastSearch.prompt.trim());
          console.log({
            prompt: prompt,
            // firebase timestamp
            result: callResponse,
            downloadURL: url,
            timestamp: serverTimestamp(),
          });
          if (prompt.trim() !== lastSubmitted.trim()) {
            // get url parameter version of prompt
            // replace spaces with dashes

            // get rid of all non-alphanumeric characters and replace spaces with dashes
            let urlPrompt = prompt
              .replace(/[^a-zA-Z0-9 ]/g, "")
              .replace(/ /g, "-");
            console.log("url " + urlPrompt);
            // create new database reference with url prompt as key

            // cehck if url prompt already exists in database
            // keep adding random numbers to the end of the url prompt until it is unique

            // first check if url prompt already exists in database
            // check if url prompt already exists in database
            const urlRef = dbRef(db, `podcasts/${urlPrompt}`);
            get(urlRef)
              .then((snapshot) => {
                if (snapshot.exists()) {
                  console.log("url prompt already exists");
                  // add random number to end of url prompt
                  urlPrompt += Math.floor(Math.random() * 1000);
                  console.log(urlPrompt);
                } else {
                  console.log("url prompt does not exist");
                }
              })
              .then(() => {
                console.log(`podcasts/${urlPrompt}`);
                const newRef = dbRef(db, `podcasts/${urlPrompt}`);

                // push new podcast to database
                set(newRef, {
                  prompt: prompt,
                  // firebase timestamp
                  result: callResponse,
                  downloadURL: url,
                  timestamp: serverTimestamp(),
                }).catch((error) => {
                  console.log(error);
                });
              });
          }
        })
        .then(() => {
          setLastSubmitted(prompt);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [audioFile]);

  useEffect(() => {
    console.log(audioFile);
  }, [audioFile]);

  // useEffect(() => {
  //   if (lastSearch.prompt !== "") {
  //     // animate scale down to 0.5 by 0.1 every 100ms
  //     let scale = imageScale;
  //     const interval = setInterval(() => {
  //       scale -= 0.002;
  //       setImageScale(scale);
  //       if (scale <= 0.5) {
  //         clearInterval(interval);
  //       }
  //     }, 1);
  //   }
  // }, [lastSearch]);

  useEffect(() => {
    // onvalue get all data from database

    const podcastRef = dbRef(db, "podcasts");
    // query database for last 5 entries based on timestamp
    const recentSearches = query(
      podcastRef,
      orderByChild("timestamp"),
      limitToLast(15)
    );

    onValue(recentSearches, (snapshot) => {
      const recentSearchesObject = [];
      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        recentSearchesObject.push([childKey, childData]);
      });

      recentSearchesObject.reverse();

      setRecentSearchString(
        recentSearchesObject.map((search) => search[1].prompt).join(", ")
      );

      setRecentSearches([...recentSearchesObject]);
    });
  }, []);

  // create a react router to handle different pages

  return (
    <>
      <div
        className="flex flex-col mt-36 xs:w-full items-center justify-center bg-black rounded-3xl bg-opacity-70 py-12 p-2 m-4"
        style={{
          maxWidth: "90%",
        }}
      >
        <div className="flex flex-row  mb-12" style={{ maxWidth: "90%" }}>
          <input
            className="border-slate-600 bg-slate-800 flex flex-row mr-4 border-2 rounded-2xl p-2 text-sm text-black shadow-sm outline-none border-8"
            type="text"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            style={{
              color: "white",
              width: "500px",
            }}
            placeholder="Enter a topic for a podcast. E.g. Mangos, or chicken nuggets."
          />
          <button
            onClick={() => {
              setRandomLoading(true);
              const randomPodcast = httpsCallable(functions, "randomPodcast");
              randomPodcast().then((result) => {
                console.log(result);
                setPrompt(result["data"]["choices"][0]["message"]["content"]);
                setRandomLoading(false);
              });
              // TextToSpeech.talk("HELLO");
            }}
            className="px-2 py-1 bg-slate-600 whitespace-nowrap text-sm font-bold rounded-xl text-sm text-white shadow-2xl"
            style={
              // add a blurry, pink drop shadow to the button when the call is pending
              {
                transition: "all 1.5s ease",
              }
            }
          >
            {randomLoading ? (
              <ThreeDots
                height="20"
                width="80"
                radius="9"
                color="white"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            ) : (
              "Surprise Me"
            )}
          </button>
        </div>
        <select
          className="flex flex-row  bg-slate-600 mb-6 p-2 text-sm text-black shadow-lg rounded-lg outline-none"
          style={{
            width: "200px",
            maxWidth: "90%",
          }}
          onChange={(e) => setSelectedVoice(e.target.value)}
        >
          {Object.keys(voice).map((key) => (
            <option value={voice[key]}>{key}</option>
          ))}
        </select>

        <button
          onClick={() => {
            // use axios to call endpoint with application/json header
            setDownloadURL("");
            setAudioFile("");
            if (callPending === false && prompt !== "") {
              setCallPending(true);

              if (prompt.trim() === lastSearch.prompt.trim()) {
                const talkAzure = httpsCallable(functions, "talkAzure");
                talkAzure({
                  text: lastSearch.result
                    .replace(/[^a-zA-Z0-9 ,.?!;:']/g, "")
                    .replace(/\./g, ". "),
                  name: selectedVoice,
                }).then((res) => {
                  console.log("code", res);
                  setAudioFile(res["data"]);
                });
                setCallPending(false);
              } else {
                const write = httpsCallable(functions, "write");
                write({ prompt: prompt })
                  .then((res) => {
                    console.log(res);
                    const newCallResponse = res["data"]["choices"][0][
                      "message"
                    ]["content"]
                      .trim()
                      .replace(/^\n+/, "");
                    setCallResponse(
                      // strip any whitespace from the beginning and end of the string
                      newCallResponse
                    );
                    // const talk = httpsCallable(functions, "talk");
                    // talk({
                    //   text:
                    //     // replace all double or single quotes with spaces
                    //     // newCallResponse
                    //     //   .replace(/["]+/g, " ")
                    //     //   // get all newlines and replace with spaces
                    //     //   .replace(/(?:\\[rn]|[\r\n]+)+/g, " "),
                    //     newCallResponse
                    //       // get rid of anything that isnot a letter, number, space, comma, period, question mark, or exclamation point
                    //       .replace(/[^a-zA-Z0-9 ,.?!:']/g, ""),
                    //   // replace em dashes with the url-encoded version
                    //   // get rid of any extra spaces
                    //   // get rid of anything thats not a letter, number, or space

                    //   name: selectedVoice,
                    // })
                    //   .then((res) => {
                    //     console.log(res);
                    //     setAudioFile(res["data"]);
                    //   })
                    //   .catch((err) => {
                    //     console.log(err);
                    //   });

                    //call onResponse function
                    const talkAzure = httpsCallable(functions, "talkAzure");
                    talkAzure({
                      text: newCallResponse
                        //       // get rid of anything that isnot a letter, number, space, comma, period, question mark, or exclamation point
                        .replace(/[^a-zA-Z0-9 ,.?!;:']/g, "")
                        .replace(/\./g, ". "),
                      name: selectedVoice,
                    }).then((res) => {
                      console.log("code", res);
                      setAudioFile(res["data"]);
                    });

                    setLastSearch({
                      prompt: prompt,
                      result: newCallResponse,
                    });
                    // make an entry in realtime database
                    setCallPending(false);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            }
            // TextToSpeech.talk("HELLO");
          }}
          style={
            // add a blurry, pink drop shadow to the button when the call is pending
            {
              boxShadow: "0 0 10px 10px #FF66C4",
              transition: "all 1.5s ease",
            }
          }
          className="bg-slate-800 text-xl font-bold  rounded-xl p-2 text-sm text-white shadow-lg"
        >
          Produce My Podcast
        </button>
      </div>

      {/* <p
        style={{
          color: "#FF66C4",
        }}
        className="mt-2 font-bold text-xs mr-2 mb-1 hidden sm:flex md:flex lg:flex"
      >
        Recently Created:
      </p>
      <div
        // wrap the recent searches in a div

        // make the div scroll horizontally
        className="flex flex-row overflow-x-scroll whitespace-nowrap mb-2 hidden sm:flex md:flex lg:flex"
        // don't show scroll bar
        style={{ maxWidth: "60%", scrollbarWidth: "none" }}
      >
        {recentSearches.map(
          // separate object into key and value
          (search, index) => (
            // <div className="mx-2 flex flex-col items-center" key={index}>
            //   <p className="text-pink-400 font-bold text-xs mb-1">
            //     {search.prompt.length > 20
            //       ? search.prompt.substring(0, 20).trim() + "..."
            //       : search.prompt}
            //   </p>
            //   <ReactAudioPlayer
            //     src={search.downloadURL}
            //     controls
            //     style={{ width: "100px", height: "30px" }}
            //   />
            // </div>

            <div
              style={{
                fontSize: "20px",
              }}
              className="text-pink-300 bg-slate-600 rounded-xl px-2 my-1 mx-2 text-black font-bold w-full whitespace-nowrap"
            >
              <Link to={`/podcast/${search[0]}`}>
                {search[1].prompt.length > 50
                  ? search[1].prompt.substring(0, 50).trim() + "..."
                  : search[1].prompt}
              </Link>
            </div>
          )
        )}
      </div> */}

      {/* 

    <p className="text-black">
    I'm updating API rn so will not work for a few minutes / hours
    </p> */}

      {downloadURL && !callPending && (
        <div className="flex flex-row my-4 justify-center items-center w-full">
          {/* <p className="text-black">{downloadURL}</p> */}
          <ReactAudioPlayer src={downloadURL} autoPlay controls />
        </div>
      )}

      {/* response and add break for every n\n characters */}
      {/* loop through text until next \n */}
      {!callPending &&
        downloadURL &&
        lastSearch.prompt !== "" &&
        callResponse !== "" && (
          <div className="flex flex-row justify-start sm:w-5/6 md:w-3/4 lg:w-1/2 xl:w-1/3">
            <h1
              style={{ color: "#FF66C4" }}
              className="text-left text-lg font-bold w-full justify-start"
            >
              Transcript:
            </h1>
          </div>
        )}

      {((lastSearch.prompt !== "" && (!downloadURL || callResponse === "")) ||
        callPending) && (
        <div className="flex flex-col justify-center items-center">
          <div className="flex flex-row justify-center items-center w-full">
            <ProgressBar
              height="80"
              width="80"
              ariaLabel="progress-bar-loading"
              wrapperStyle={{}}
              wrapperClass="progress-bar-wrapper"
              borderColor="#7bb5fb"
              barColor="#FF66C4"
            />
          </div>

          <h1 className="text-blue-300 text-3xl text-center w-108 text-left text-lg font-bold w-full justify-start text-black">
            We are producing your custom podcast.
            <br />
            It should only take about a minute.
          </h1>
        </div>
      )}

      {!callPending &&
        downloadURL &&
        lastSearch.prompt !== "" &&
        callResponse !== "" && (
          <div className="flex flex-col justify-start max-h-48 overflow-y-scroll sm:w-5/6 md:w-3/4 lg:w-1/2 xl:w-1/3">
            {!callPending && (
              <p className="text-left text-black text-sm px-8">
                {callResponse.split("\n").map((item, i) => {
                  return (
                    <span style={{ color: "white" }} key={i}>
                      {item}
                      <br />
                    </span>
                  );
                })}
              </p>
            )}
          </div>
        )}
    </>
  );
}

export default Main;
